import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {StorageService} from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'dialog-download-zip',
  templateUrl: './dialog-download-zip.component.html',
  styleUrls: ['./dialog-download-zip.component.css']
})
export class DialogDownloadZipComponent implements OnInit {
  public selectedId: string;
  public loading: boolean;
  public multiselect=false;
  public file: any;
  public actualPercent: number;
  public bitsLoaded: number;
  public bitsTotal: number;
  public isPublic: boolean;
  public name: string;
  private stop: boolean;
  private actualTimeout;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DialogDownloadZipComponent>,
              private api: APIHelper,
              private storage: StorageService) {
  }

  ngOnInit(): void {
    this.actualTimeout = null;
    let datas=[];
    this.stop = false;
    this.actualPercent = 0;
    this.loading = true;
    this.multiselect=this.data.multiselect;

    if(!this.multiselect){
      this.file = this.data.file;
      this.selectedId = this.data.file.id;
      this.isPublic = this.data.isPublic;
      this.name = this.data.file.name;
      const data = {
        nodeRef: 'validationLabel' + this.selectedId
      };
      datas = [data];
   
      
    }
    else {
      this.name="Téléchargement"
       for(let i = 0 ;i<this.data.files.length;i++){
        
         datas.push({nodeRef:'workspace://SpacesStore/'+this.data.files[i].entry.id});
       }
     

    }
   

    this.api.requestApi({action: API_URLS.nodes.downloadZip, method: 'POST', datas: datas}).then((res) => {
      this.loading = false;
      const id = /[^/]*$/.exec(res.nodeRef)[0];

      this.recursiveCheckDownload(id);
    });
  }

  private recursiveCheckDownload(id: string) {
    let url = '';
    this.api
      .requestApi({
        action: API_URLS.nodes.downloadsState.replace(':id', id)
      })
      .then(res => {
        if (res.filesAdded) {
          this.bitsTotal = res.totalBytes;
          this.bitsLoaded = res.bytesAdded;
          this.actualPercent = Math.round(
            (this.bitsLoaded / this.bitsTotal) * 100
          );
        }

        if (this.stop) {
          return;
        } else if (res.status !== 'DONE') {
      
          // Attendre 1/2 secondes et relancer le call
          this.actualTimeout = setTimeout(() => {
            this.recursiveCheckDownload(id);
          }, 50);

        }
        else {

         
          this.downloadFile(id);
          this.dialogRef.close(id);

          this.api.requestApi({action: API_URLS.nodes.deletezip.replace(':id', id), method: 'DELETE'}).then((res) => {

            this.dialogRef.close(true);

          });

        }

      });
  }


  private downloadFile(id: string) {

    let url = '';
    const token = this.storage.getAsync({key: 'token'});
    if (!this.isPublic) {
      url = this.api.url + API_URLS.nodes.downloadContentZip.replace(':id', id);
      url += '/' + this.name + '.zip?attachment=true&alf_ticket=' + token;
    } else {
      url =
        url = this.api.url + API_URLS.nodes.downloadContentZip.replace(':id', id);
      url += '/mouadh.zip?attachment=true&alf_ticket=' + token;
    }


    window.open(url, '_blank');
    this.dialogRef.close(true);
  }
}
